<template>
  <div class="container-fluid">
    <!-- 第一部分：背景图与文本 -->
    <!--    <div class="bg-image" style="background-image: url('../../public/images/services/bg.png'); background-size: cover; height: 300px;">-->
    <div class="container-fluid">
      <div class="row bg-service-image-container h-100 w-100 no-gutters">
        <div class="col-12 position-relative">
          <img src="../assets/images/service/service-welcome.png" alt="Service Welcome Image" class="img-fluid w-100"/>
          <div class="gradient-overlay position-absolute bottom-0 w-100 h-25"
               style="background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 255, 0.7));"></div>
          <div class="text-container position-absolute bottom-0 w-100 justify-content-center align-items-center">
            <p class="text-left text-white mb-0 pb-0 pl-md-5 pr-md-5 px-sm-1 font-class-ref-title">
              {{ $t("h.service_title") }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二部分：服务列表 -->
    <div class="container-fluid">
      <h2 class="text-center mt-5 py-4 pl-3 mb-4 font-weight-bold boldText">{{ $t("h.offer_service") }}</h2>
    </div>

    <!-- 第一个2x2的服务格子 -->
    <div class="container">
      <div class="row equal-height">
        <div class="col-md-6 mb-5 mb-md-1 p-md-5 pt-md-3 px-md-3" v-for="(service, index) in services" :key="index">
          <div class="card bg-light">
            <img style="border-radius: 15px 15px 0 0;"  :src="require(`../../public/images/services/${service.image}.png`)" class="img-fluid mt-0"
                 :alt="$t(`h.offer_service_alt${index+1}`)">
            <div class="card-body" style="background-color: rgba(255, 255, 255);border-radius: 15px;">
              <h4 class="font-weight-bold text-left boldText">{{ $t(`h.offer_service_title${index + 1}`) }}</h4>
              <br>
              <p class="card-text text-left font-class-ref text-black-50">{{ $t(`h.offer_service_${index + 1}`) }}</p>
            </div>
          </div>
        </div>
      </div>

      <div  class="container wide-container-class">
        <div style="border-radius: 15px;"  class="card bg-light tangzhecard" >
          <div class="row align-items-start align-content-center">
            <div  class="card-body col-md-6" style="padding: 3em;">
              <h3 class=" text-left font-weight-bold boldText">{{ $t("h.taxPolicy") }}</h3>
               <br>
              <p class="card-text text-left font-class-ref text-black-50 ">{{ $t("h.taxPolicyInfo") }}</p>
            </div>
            <div class="col-md-6">
              <img  src='../../public/images/services/wide.png'
                   class="img-fluid wide-img-class" alt="Service Image">
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 第三部分：灰色背景的文本 -->
    <div class="container-fluid mt-5 mb-1 p-4" style="background-color: rgba(242, 246 ,255); ">
      <div class="text-center justify-content-center align-content-center">
        <p  class="font-class-ref px-1 pt-1 text-black-50">{{ $t("h.serviceSummery") }}</p>
      </div>
    </div>
      <!-- 第一部分：三列布局 -->
    <!-- <div class="container-fluid px-0 mx-0">
      <div class="row bg-culture-image-container h-100 w-100 no-gutters">
        <div class="col-12 position-relative">
          <img src="../assets/images/culture/cul-welcome.png" alt="Service Welcome Image" class="img-fluid w-100"/>
          <div class="gradient-overlay position-absolute bottom-0 w-100 h-25"
               style="background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 255, 0.7));"></div>
          <div class="text-container position-absolute bottom-0 w-100 justify-content-center align-items-center">
            <p class="text-left font-weight-bold text-white mb-0 pb-0 pl-5 pr-5 font-class-ref-title">
              {{ $t("h.company_culture_chose") }}
            </p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 第二部分：标题+文本 -->
    <!-- <div class="container">
      <div class="row mb-4 mt-4">
        <div class="col-12">
          <h4 class="font-weight-bold text-center">{{ $t("h.company_culture_title") }}</h4>
          <p class="text-center font-class-ref text-black-50 px-3">{{ $t("h.company_culture_info") }}</p>
        </div>
      </div>
    </div> -->


    <!-- 第三部分：两列布局 -->
    <!-- <div class="container-fluid pt-2 pb-2"
         :style="{ backgroundImage: 'url(' + require('@/assets/images/culture/bg.png')+ ')' }">
      <div class="row m-5">
        <div class="card border-0">
          <div class="row align-items-start no-gutters home-text-7"
               :style="{ backgroundImage: 'url(' + require('@/assets/images/culture/bg.png')+ ')' }">
            <div class="col-md-6">
              <img src="@/assets/images/culture/bg-on.png" class="card-img" alt="Card image">
            </div>
            <div class="col-md-6"> 
              <div class="card-body pt-3 px-0 pl-md-3">
                <p class=" text-left font-class-ref">
                  {{ $t("h.culture_introduction1") }}
                </p>
                <p class=" text-left font-class-ref">
                  {{ $t("h.culture_introduction2") }}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->


    <!-- 第四部分：3*3布局 -->

    <div class="container-fluid mt-5 ">
      <div class="mb-5 row align-items-center justify-content-center">
        <div class="col-12">
          <h2 class="text-center boldText">{{ $t("h.choose_title") }}</h2>
          
          <p class="text-left font-class-ref px-5 pt-3 text-black-50">{{ $t("h.choose_reason") }}</p>
        </div>
      </div>

      <div class="row justify-content-around ml-md-4 mr-md-4">
        <div v-for="(item, index) in choseReason" :key="index"
             class="card-css-class col-12 "
             style="background-color: rgba(0, 83, 255); margin: 1vw; border-radius: 15px;">
          <img :src="require(`@/assets/images/culture/${item.path}.png`)" class="rounded p-md-3 p-3 mb-md-2 mb-4 mt-2 reason-label-class"
               alt="">
          <p class="text-white mb-2 font-weight-bold text-center boldText">{{ $t(`h.choose_reason_title${index + 1}`) }}</p>
          <p class="text-white font-class-ref-1 text-left mb-1">{{ $t(`h.choose_reason_content${index + 1}`) }}</p>
        </div>
      </div>
    </div>


    <!-- 第五部分：左右各一半的图片 -->
    <!-- <div class="container-fluid justify-content-center p-2 mb-4">
      <div class="row mt-3 justify-content-center">
        <div class="col-md-6 ">
          <img src="../../public/images/culture/cul-6-1.png" class=" rounded w-100 h-100" alt="Image 3">
        </div>
        <div class="col-md-6 ">
          <img src="../../public/images/culture/cul-6-2.png" class=" rounded w-100 h-100" alt="Image 4">
        </div>
      </div>
    </div> -->

   
  </div>
</template>

<script>
import {services_zh} from "@/constant/zh/services";
import {chooseReasonInfo_zh} from "@/constant/zh/choseReasonInfo"
export default {
  name: 'Services',
  data() {
    return {
        // 在这里定义你的数据属性
      choseReason: chooseReasonInfo_zh,
      services: services_zh
    };
  }
};
</script>

<style scoped>
.boldText{
  font-size: 40px;
    font-weight: 700;
}
.card-title{
  font-size: 30px;
}
/* 如果有需要，可以在这里添加一些特定样式 */
/* 添加响应式样式，例如使用Bootstrap的栅格系统 */
.cul-first {
  background-color: rgba(242, 242, 242);
  padding: 0 !important;
}

.cul-text-7 {
  background-color: rgba(241, 243, 242);
}

.bg-culture-image-container {
  /* 确保容器有足够的高度来显示图片和渐变 */
  height: 90vh; /* 或根据您的需求调整 */
  overflow: hidden; /* 防止图片或渐变溢出容器 */
}

.gradient-overlay {
  /* 渐变层覆盖在图片底部 */
  position: absolute;
  bottom: 0;
  left: 0;
  height: 25%; /* 渐变层的高度，您可以根据需要调整 */
  pointer-events: none; /* 防止渐变层影响下方的点击事件 */
}

.text-container {
  /* 文本容器，使用flex布局在渐变层上居中显示文本 */
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: flex-end; /* 垂直居底（因为已经设置了bottom: 0） */
  width: 100%;
  z-index: 1; /* 确保文本在渐变层之上 */
  padding: 0.8rem !important;
}

/*默认字体大小*/
.font-class-ref {
  font-size: 1.2vw
}

.font-class-ref-1 {
  font-size: 1.2vw
}


.reason-card-class {
  //min-height: 100vh;
}

.reason-label-class {
  height: 25%;
}

/* 等高 */
.row.equal-height {
  display: flex;
  flex-wrap: wrap;
}

.row.equal-height > [class^="col-"] {
  display: flex;
  flex-direction: column;
}

.card-css-class {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 30%;
     max-width: 25% !important;
    height: 60vh;
}

@media (max-width: 768px) {
  .font-class-ref {
    font-size: 1.5vw
  }
}

@media (max-width: 567px) {
  .font-class-ref {
    font-size: 5vw
  }

  .font-class-ref-1 {
    font-size: 5vw
  }

  .reason-card-class {
    //min-height: 55vh;
  }

  .card-css-class {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    flex: 0 0 100%;
    max-width: 90% !important
  }


  .reason-label-class {
    height: 20%;
  }
}


.card-title{
  font-size: 30px;
}

.container-fluid {
  padding: 0;
}

.bg-service-image-container {
  /* 确保容器有足够的高度来显示图片和渐变 */
  height: 90vh; /* 或根据您的需求调整 */
  overflow: hidden; /* 防止图片或渐变溢出容器 */
}

.gradient-overlay {
  /* 渐变层覆盖在图片底部 */
  position: absolute;
  bottom: 0;
  left: 0;
  height: 25%; /* 渐变层的高度，您可以根据需要调整 */
  pointer-events: none; /* 防止渐变层影响下方的点击事件 */
}

.text-container {
  /* 文本容器，使用flex布局在渐变层上居中显示文本 */
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: flex-end; /* 垂直居底（因为已经设置了bottom: 0） */
  width: 100%;
  z-index: 1; /* 确保文本在渐变层之上 */
  padding: 0.8rem !important;
}

/*默认字体大小*/
.font-class-ref {
  font-size: 1.5vw
}

.font-class-ref-title {
  font-size: 1.5vw;
}



/* 等高 */
.row.equal-height {
  display: flex;
  flex-wrap: wrap;
}

.row.equal-height > [class^="col-"] {
  display: flex;
  flex-direction: column;
}

.row.equal-height .card {
  border-radius: 15px;
  flex: 1 1 100%; /* Flex grow, shrink, basis */
  display: flex;
  flex-direction: column;
}

.row.equal-height .card-body {
  flex: 1 1 auto; /* This ensures the card-body expands to fill the card */
}
.card-body {
  padding:7.25em ; 
}

.wide-img-class {
height: auto;
    max-width: 100%;
  }

.wide-container-class {
  padding: 2rem !important;
}

@media (max-width: 768px) {
    .card-body {
  padding:1em ; 
}
  .font-class-ref {
    font-size: 1.7vw
  }
  .boldText{
    font-size: 30px;
  }
 .wide-container-class {
  padding: 0rem !important;
}
}

@media (max-width: 567px) {
    
  .card-body {
  padding:1em ; 
}
    .boldText{
    font-size: 30px;
  }
  .font-class-ref {
    font-size: 5vw
  }

  .font-class-ref-title {
    font-size: 2.5vw;
  }

  .wide-img-class {
    height:auto;
    max-width: 100%;
    border-radius: 15px;
  }

  .wide-container-class {
     padding: 0rem !important;
  }
}




</style>
